import { render, staticRenderFns } from "./SocialLink.vue?vue&type=template&id=1a8242d4&scoped=true&"
import script from "./SocialLink.vue?vue&type=script&lang=js&"
export * from "./SocialLink.vue?vue&type=script&lang=js&"
import style0 from "./SocialLink.vue?vue&type=style&index=0&id=1a8242d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8242d4",
  null
  
)

export default component.exports